import { useState } from 'react';
import { IExercise } from '../models/exercise';

export const useExerciseListHook = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(true);

  const exerciseTypes = {
    single_answer: 'única',
    multiple_answer: 'de múltipla escolha',
    discursive: 'discursiva',
  };

  const onFavorite = (exercise: IExercise, isFavorite: boolean) => {
    const newExercise = { ...exercise, favorite: isFavorite };
    return newExercise;
  };

  const convertMathGraphs = () => {
    if (typeof window?.MathJax !== 'undefined') {
      window.MathJax.typesetPromise();
    }
  };

  const setExerciseAlternative = (
    alternativeId: string,
    exercise: IExercise
  ) => {
    if (!exercise.done) {
      exercise.hasAlternativeSelected = true;
      exercise.alternatives = exercise.alternatives.map((alternative) => {
        if (alternative.id === alternativeId) {
          alternative.selected =
            exercise.exerciseType === 'single_answer'
              ? true
              : !alternative.selected;
        } else {
          if (exercise.exerciseType === 'single_answer') {
            alternative.selected = false;
          }
        }
        return alternative;
      });
    }

    return exercise;
  };

  const tryAgain = (exercise: IExercise) => {
    exercise.done = false;
    exercise.showAnswer = false;
    exercise.hasAlternativeSelected = false;
    exercise.alternatives = exercise!.alternatives.map((alternative) => {
      (alternative.selected = false), (alternative.status = 'default');

      return alternative;
    });

    return exercise;
  };

  const viewAnswer = (exercise: IExercise) => {
    exercise.showAnswer = !exercise.showAnswer;
    exercise.alternatives = exercise!.alternatives.map((alternative) => {
      if (alternative.correct) {
        alternative.status = exercise.showAnswer ? 'correct' : 'default';
      }

      return alternative;
    });

    return exercise;
  };

  return {
    showVideo,
    isModalOpen,
    exerciseTypes,
    onFavorite,
    setExerciseAlternative,
    tryAgain,
    viewAnswer,
    setModalOpen,
    setShowVideo,
    convertMathGraphs,
  };
};
